import React, { useContext, useEffect, useState } from 'react'
import { useUserTokens } from '@reservoir0x/reservoir-kit-ui'
import { PortfolioSortingOption } from 'components/common/PortfolioSortDropdown'
import { useAccount } from 'wagmi'
import { blockchainData } from 'constants/DragonsHolder'
import { ChainContext } from 'context/ChainContextProvider'

interface TokensProps {
  selectedToken: number | undefined
  setTokenId: (tokenId: number) => void
}

const Tokens = ({ setTokenId, selectedToken }: TokensProps) => {
  const [sortByType, setSortByType] =
    useState<PortfolioSortingOption>('acquiredAt')

  const [filterCollection, setFilterCollection] = useState<string | undefined>(
    undefined
  )
  const { address } = useAccount()
  const { chain } = useContext(ChainContext)

  let tokenQuery: Parameters<typeof useUserTokens>['1'] = {
    limit: 20,
    sortBy: sortByType,
    collection: filterCollection,
    includeTopBid: true,
    includeRawData: true,
    includeAttributes: true,
  }

  if (chain.name) {
    tokenQuery.contract = getCollectionAddress(chain.name)
    console.log(`Token contract Address ${getCollectionAddress(chain.name)}`)
    console.log(chain.name)
  }

  const {
    data: tokens,
    fetchNextPage,
    mutate,
    isFetchingPage,
    isValidating,
  } = useUserTokens(address, tokenQuery, { revalidateIfStale: true })

  function getCollectionAddress(chainName: string): string {
    if (chainName.toLowerCase() == 'polygon mumbai') {
      chainName = 'mumbai'
    }
    if (chainName.toLowerCase() == 'binance smart chain testnet') {
      chainName = 'bsc-testnet'
    }
    const sepoliaData = blockchainData.find(
      (data) => data.chain === chainName.toLocaleLowerCase()
    )
    return sepoliaData?.collectionAddress!
  }
  if (tokens) {
    console.log(tokens)
  }
  return (
    <div className="flex flex-row w-full flex-wrap">
      {tokens.map((_item: any, id: any) => (
        <div
          key={id}
          className={`m-2 shadow-lg rounded-lg flex flex-col items-center relative ${
            Number(_item.token.tokenId) == selectedToken
              ? 'border-4 border-primary'
              : ''
          }`}
          onClick={() => setTokenId(_item.token.tokenId)}
        >
          <img
            src={_item.token.image}
            className="rounded-lg h-[200px] w-[200px] object-cover"
          />
          <div className="text-lg font-bold text-center absolute bottom-0 h-8 w-full rounded-b-lg bg-[#0000005C] text-white">
            {`${_item.token.name} ${_item.token.tokenId}`}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Tokens
